import { RootState } from 'store/root-reducer';
import { NotificationMessageData } from './types';

export const getNotifications = (state: RootState): Array<NotificationMessageData> => state.admin.notifications.data;
